import { useEffect, useState } from "react";
import { fetchGet } from "app/utils/request";

export interface SpaceTemplateOption {
  id: string;
  name: string;
}

/**
 * The coach's own visible space templates (CN-2595), used to link a booking
 * option to the template applied to the space auto-created for a new athlete
 * who books it.
 */
export default function useSpaceTemplates() {
  const [templates, setTemplates] = useState<SpaceTemplateOption[]>([]);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    // Guards every state update: the request layer resolves/rejects after
    // unmount otherwise, which React warns about.
    let active = true;
    setPending(true);

    fetchGet<SpaceTemplateOption>("space_templates", {}, { version: 1 }, controller.signal)
      .then((res) => {
        if (!active) {
          return;
        }
        setTemplates(Array.isArray(res) ? res : []);
      })
      .catch((error) => {
        // responseHandler turns an aborted fetch into { status: 499 }, not an
        // AbortError, so check the signal and that status rather than the name.
        if (!active || controller.signal.aborted || error?.status === 499) {
          return;
        }
        console.error("Error fetching space templates:", error);
      })
      .finally(() => {
        if (active) {
          setPending(false);
        }
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, []);

  return { templates, pending };
}
